interface LabelProps extends React.HTMLProps<HTMLLabelElement> {
  isRequired?: boolean;
  showOptionalText?: boolean;
}

export function Label({ isRequired, showOptionalText, children, ...props }: LabelProps) {
  return (
    <label {...props} className="flex! gap-1 text-sm font-normal">
      {children}
      {!isRequired && showOptionalText && <span className="text-blue-grey-400">(optional)</span>}
      {isRequired && <span className="text-red-600">*</span>}
    </label>
  );
}
